if($('footer#footer .contact-box').length){
   // $('.contact-box span.tel a').html($('.contact-box span.tel a').html().replace('+420', '<span style="font-weight:400;">+420</span>'))
    $('footer#footer .contact-box').append('<ul class="socialList"></ul>')
    $('.socialList').append($('footer#footer .contact-box>ul span.instagram').closest('li'))
    $('.socialList').append($('footer#footer .contact-box>ul span.facebook').closest('li'))
    $('.socialList').append($('footer#footer .contact-box>ul span.tiktok').closest('li'))
    $('footer#footer .contact-box>ul span.tiktok a').text('')
}

